{
  "depth": {
    "chapter": "Chapter",
    "heading": "Heading",
    "subheading": "Subheading",
    "national": "National line"
  },
  "voter": {
    "lexical": "Lexical (official wording)",
    "semantic": "Semantic (meaning)",
    "precedent": "Precedents (moderator-confirmed)",
    "llm": "AI (chooses among table codes only)"
  },
  "classifier": {
    "explainer": "Several local sources vote on the code: the official HS wording, meaning-based search, codes moderators confirmed for similar products and, when enabled, an AI that may only choose among table codes. Every code and description shown is from the official HS table.",
    "running": "Classifying…",
    "error": "Could not classify this product.",
    "pathLabel": "Classification path",
    "useThis": "Use this",
    "selected": "Selected",
    "confidence": "Confidence {{value}}",
    "alternatives": "Other candidates (share of the votes)",
    "voteShare": "Share of the fused votes",
    "refineLabel": "Add a detail to narrow it down (material, use, processing…)",
    "refinePlaceholder": "e.g. frozen, of stainless steel, for retail sale",
    "rerun": "Classify again",
    "clearWithin": "Search outside {{code}}",
    "withinNote": "(searched within {{code}})",
    "version": "HS {{version}} table",
    "deepestHelp": "The sources agree down to the 6-digit subheading.",
    "partialHelp": "The sources agree this far but not below, so it stops here rather than guess. Answer the question or add a detail to go deeper, or use this code.",
    "status": {
      "classified": "Classified to the {{depth}}.",
      "needsAnswer": "Agreed down to the {{depth}} — one question to go deeper.",
      "noAgreement": "The sources don't agree on a chapter yet. Answer the question below, add a detail, or pick a candidate."
    },
    "reason": {
      "too_vague": "That's too vague to classify. Add what the product is made of or used for.",
      "no_match": "No HS code matches this description. Try other words, or enter the code yourself.",
      "table_not_loaded": "The HS table isn't loaded on this server yet.",
      "unknown": "No code could be proposed."
    },
    "votes": {
      "title": "Votes per source",
      "voter": "Source",
      "weight": "Weight",
      "ballot": "Ranked votes",
      "skipped": "skipped: {{why}}",
      "noVotes": "No votes above its threshold"
    }
  },
  "estimate": {
    "range": "{{low}} – {{high}}",
    "total": "Duties and taxes (gross)",
    "percentOfValue": "{{low}}–{{high}}% of the goods value",
    "net": "After VAT reclaim",
    "netHelp": "What a VAT-registered importer is left paying once recoverable taxes are reclaimed.",
    "confidenceLabel": "Confidence",
    "confidence": {
      "low": "Low",
      "medium": "Medium",
      "high": "High"
    },
    "layersTitle": "What makes up the range",
    "layersHelp": "HS {{code}} ({{depth}}): {{description}}",
    "customsValueLine": "Customs value: {{range}} ({{basis}}).",
    "basis": {
      "cif": "CIF basis: goods + freight + insurance",
      "transaction": "transaction value, freight excluded",
      "unknown": "basis unknown, both covered"
    },
    "legendLow": "Low end",
    "legendHigh": "Up to the high end",
    "scaleNote": "All bars share one scale: the gross total's high end. A wide bar means a wide range, usually because a detail (HS depth, province, Incoterm, freight) is unknown.",
    "rate": "{{rate}}%",
    "rateRange": "{{low}}–{{high}}%",
    "warningsTitle": "Warnings",
    "applies": "applies",
    "mayApply": "may apply",
    "assumptionsTitle": "Assumptions",
    "sourcesTitle": "Sources",
    "sourceKind": {
      "tax": "Tax",
      "duty": "Duty",
      "agreement": "Agreement",
      "rule": "Rule",
      "fx": "FX"
    },
    "asOf": "as of {{date}}"
  },
  "form": {
    "origin": "Goods from",
    "destination": "Imported into",
    "withData": "Curated data",
    "otherCountries": "Other (wide fallback range)",
    "destinationTax": "{{name}} {{rate}}% · {{basis}}",
    "vat": "VAT",
    "noData": "No curated data: you'll get a wide range with low confidence.",
    "province": "Province / state",
    "provinceUnknown": "Unknown (range covers all)",
    "hsCode": "HS code (any depth)",
    "hsHint": "A shallower code gives a wider range.",
    "hsUnknown": "Not in the HS table.",
    "value": "Value of the goods",
    "currency": "Currency",
    "incoterm": "Incoterm",
    "incotermUnknown": "Unknown",
    "freight": "Freight (optional)",
    "insurance": "Insurance (optional)",
    "vatRegistered": "Importer VAT-registered?",
    "vatUnknown": "Unknown",
    "optionalHint": "Optional details narrow the range: without freight, a CIF destination adds an assumed 3–15% uplift.",
    "working": "Working…"
  },
  "tool": {
    "title": "Duty & tax estimate",
    "subtitle": "A free, local estimate of import duty and taxes — always a range with its assumptions and sources, never a single figure.",
    "formTitle": "Shipment",
    "formHelp": "Origin, destination, HS code and value are enough. Every extra detail narrows the range.",
    "submit": "Estimate",
    "error": "Could not estimate."
  },
  "deal": {
    "title": "Trade terms & duty / tax estimate",
    "loadError": "Could not load the trade terms.",
    "savedAt": "Set by a MatchPoint moderator · last change {{date}}.",
    "notSetModerator": "Not set yet. The fields below are suggested from the deal (supplier → buyer, matched product's HS code); save them to get an estimate both companies can see.",
    "notSetCompany": "Your MatchPoint moderator hasn't set the shipment terms yet. The estimate appears here once they do.",
    "set": "Set terms",
    "edit": "Edit terms",
    "save": "Save terms",
    "saveError": "Could not save the terms.",
    "estimateError": "No estimate yet.",
    "fromProduct": "(from the matched product)",
    "note": "Note",
    "unset": "—"
  }
}
